import { render } from "./TrainingHome.vue?vue&type=template&id=54f23b70&scoped=true"
import script from "./TrainingHome.vue?vue&type=script&lang=js"
export * from "./TrainingHome.vue?vue&type=script&lang=js"

import "./TrainingHome.vue?vue&type=style&index=0&id=54f23b70&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f23b70"]])

export default __exports__